import { isDefined } from '@sama/js-core';
import { without } from 'lodash';
import {
  getProjectionType,
  hasCalibrationData,
} from '../../../../cross-team-shared/misc-utils/projection-utils';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { RendererLayer } from '../../render-utils';
import { RenderConfiguration } from '../abstract-mesh-helper';

export function getThinLineLayers(
  state: PointCloudContentState,
  renderConfig: RenderConfiguration,
  layers: RendererLayer[],
) {
  return hasCalibrationData(state.task, renderConfig.outputName) &&
    layers.includes(RendererLayer.Projection)
    ? [RendererLayer.Projection]
    : [];
}

export function getThickLineLayers(
  state: PointCloudContentState,
  renderConfig: RenderConfiguration,
  layers: RendererLayer[],
) {
  const renderedOutput = renderConfig.outputName;
  const calibrationData = state.calibrationData[renderedOutput];
  if (!isDefined(calibrationData)) {
    return layers;
  }

  const projectionType = getProjectionType(
    calibrationData,
    state.task,
    renderedOutput,
  );

  return projectionType === 'pinhole'
    ? layers
    : without(layers, RendererLayer.Projection);
}

export function getSubPointLayers(
  state: PointCloudContentState,
  renderConfig: RenderConfiguration,
  initialLayers: RendererLayer[],
) {
  return hasCalibrationData(state.task, renderConfig.outputName)
    ? initialLayers
    : without(initialLayers, RendererLayer.Projection);
}
